
type Props = {
	lookupValue: string,
	entityName: string,
	entityStatus: string,
	entityAddress: string,
	title?: string;
}

/**
 * Displays information from the <AbrOrAsicSearchResponse /> search results
 */
export const AustralianEntitySearchBoxSegment: React.FunctionComponent<Props> = ({
	lookupValue,
	entityName,
	entityStatus,
	entityAddress,
	title,
}) => {
	return (
		<section className="review-segment">
			{title && <header><h4>{title}</h4></header>}
			<div>
				<p><strong>Entity name: </strong>{entityName}</p>
				<p><strong>Entity status: </strong>{entityStatus}</p>
				<p><strong>Entity address: </strong>{entityAddress}</p>
				<p><strong>Business Number: </strong>{lookupValue}</p>
			</div>
		</section>
	)
}
